import React from "react";
import { Box } from "@mui/material";
import { T, SERIES_SOFT } from "utils/backrrTokens";
import BreakdownBars from "./BreakdownBars";
import CategorySectorBreakdown from "./CategorySectorBreakdown";

// One surface, three columns, hairline seams — instead of three bordered cards.
// The three dimensions describe the same population, so reading them as one
// object is correct; three boxes made them look like three unrelated widgets
// and added two more borders to a page that already had too many.
const BreakdownPanel = ({ data, isLoading }) => {
  return (
    <Box
      sx={{
        border: `1px solid ${T.border}`,
        borderRadius: T.radius,
        overflow: "hidden",
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "1fr 1fr", lg: "repeat(3, 1fr)" },
        // Same hairline-by-gap technique as the KPI strip: one rule per seam,
        // and it reflows correctly when the grid wraps.
        gap: "1px",
        backgroundColor: T.border,
        "& > *": { backgroundColor: T.surface },
      }}
    >
      <BreakdownBars title="Top Countries" block={data?.by_country} isLoading={isLoading} tint={SERIES_SOFT[0]} />
      <BreakdownBars title="Stage" block={data?.by_stage} isLoading={isLoading} tint={SERIES_SOFT[1]} />
      <CategorySectorBreakdown block={data?.by_category} isLoading={isLoading} />
    </Box>
  );
};

export default BreakdownPanel;
